// Shared utility
export const isValidNumber = (value) => /^[0-9.]+$/.test(value);
export const isValidNumberZeroAllowed = (value) =>
  /^0$|^[1-9][0-9]*([.][0-9]+)?$|^0[.][0-9]+$/.test(value);

// Shared ratio calculator
export const calculateRatio = (a, b) => {
  const valA = parseFloat(a);
  const valB = parseFloat(b);
  if (!valB || isNaN(valA) || isNaN(valB)) return 0;
  return valA / valB;
};

export const basicChecks = (value, label, allowZero = false) => {
  if (!value) return `${label} is required`;
  if (/\s/.test(value)) return `${label} should not contain spaces`;

  if (allowZero) {
    if (!isValidNumberZeroAllowed(value)) return `Invalid value in ${label}`;
  } else {
    if (!isValidNumber(value)) return `Invalid value in ${label}`;
  }
  return null;
};

export const validateNumericValue = (fieldLable, allowZero = false) => ({
  validator(_, value) {
    const error = basicChecks(value, fieldLable, allowZero);
    return error ? Promise.reject(error) : Promise.resolve();
  },
});

export const checkAllowedValues = (isCollated = false, fieldName = "") => ({
  validator(_, value) {
    if (!value) return Promise.resolve(); // Let "required" handle empty

    let allowedAttritionValues = [
      "0.25",
      "0.5",
      "0.75",
      "1",
      "1.25",
      "1.5",
      "1.75",
      "2",
      "2.25",
      "2.5",
      "2.75",
      "3",
    ];

    if (isCollated && fieldName === "root_resorption_R") {
      allowedAttritionValues.unshift(0, "0");
    }

    const allowedNumbers = allowedAttritionValues.map(parseFloat);
    const inputNumber = parseFloat(value);

    if (!allowedNumbers.includes(inputNumber)) {
      return Promise.reject(
        `Value must be one of: ${allowedAttritionValues.join(", ")}`
      );
    }

    return Promise.resolve();
  },
});
